import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { FaSortAmountUp, FaSortAmountDown, FaArrowRight, FaArrowLeft, FaPlus, FaEdit, FaCheckCircle, FaPercentage, FaCircle, FaStopwatch, FaMoneyBill } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import { BsBriefcase, BsCashCoin } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import axios from 'axios';
import useAuth from '../dashboard/useAuth';
import Select from "react-select";
import { getAuthToken } from '../../authToken';

const JournalPaiementUtilisateur = ({ titre }) => {
    useAuth();
    const [paiements, setPaiements] = useState([]);
    const [utilisateur, setUtilisateur] = useState(null);
    const [souscription, setSouscription] = useState(null);
    const [selectedPaiement, setSelectedPaiement] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'descending' });
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { souscription_id } = location.state || {};

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };

    const [showAjoutPaiementModal, setShowAjoutPaiementModal] = useState(false);
    const [showModifierPaiementModal, setShowModifierPaiementModal] = useState(false);
    const [nouveauPaiement, setNouveauPaiement] = useState({
        versement: 'total',
        montant: '',
        reste_a_payer: '',
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = paiements.length;

    const user_id = localStorage.getItem('user_id');

    useEffect(() => {
        document.title = "eTrainApp | Journal des paiements";
        fetchUtilisateur();
        fetchSouscription();
        fetchPaiementsSouscription();
    }, [souscription_id, user_id]);

    const fetchUtilisateur = async () => {
    try {
        const token = localStorage.getItem('access_token');

        const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        
            setUtilisateur(response.data);
    } catch (error) {
        console.error('Erreur lors de la récupération des données utilisateur', error);
    }
};

    const fetchSouscription = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/souscription-info/${souscription_id}/`);
            setSouscription(response.data);

            // Pré-remplir le nouveau paiement avec les infos de la souscription
            setNouveauPaiement(prev => ({
                ...prev,
                produit: response.data.formation ?
                    [`${response.data.formation.nom} ${response.data.formation.periode}`] :
                    [response.data.produit.nom],
                prix: response.data.formation ?
                    response.data.formation.prix :
                    response.data.produit.prix
            }));
        } catch (error) {
            console.error('Error fetching subscription:', error);
        }
    };

    const fetchPaiementsSouscription = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-paiements-souscription/${souscription_id}/${user_id}/`);
            const data = await response.json();
            if (response.ok) {
                setPaiements(data.paiement);
            } else {
                console.error('Erreur lors de la récupération des paiements. Code:', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePaiement = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/paiement-souscription/${souscription_id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    nouveauPaiement,
                    user_id,
                    souscription_id
                }),
            });
            const data = await response.json();

            if (response.ok) {
                showAlert("Paiement effectué avec succès !");
                fetchSouscription();
                fetchPaiementsSouscription();
                setShowAjoutPaiementModal(false);
                setNouveauPaiement({
                    versement: 'total',
                    montant: '',
                    reste_a_payer: '',
                });
            } else {
                console.error("Erreur lors de l'enregistrement du paiement.", data);
                showAlertModal(data.error || "Erreur lors de l'enregistrement du paiement", 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlertModal("Erreur réseau lors de l'enregistrement du paiement", 'danger');
        }
    };

    const handleModifierPaiement = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-paiement-souscription/${selectedPaiement.id}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    paiement: selectedPaiement,
                    souscription_id
                }),
            });
            const data = await response.json();

            if (response.ok) {
                showAlert("Paiement modifié avec succès !");
                fetchPaiementsSouscription();
                setShowModifierPaiementModal(false);
            } else {
                console.error("Erreur lors de la modification du paiement.", data);
                showAlertModal(data.error || "Erreur lors de la modification du paiement", 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlertModal("Erreur réseau lors de la modification du paiement", 'danger');
        }
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleRowClick = (paiement) => {
        setSelectedPaiement(paiement);
    };

    const sortedPaiements = [...paiements].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const filteredPaiements = sortedPaiements.filter(paiement =>
        paiement.date_paiement.toLowerCase().includes(searchTerm.toLowerCase()) ||
        paiement.versement.toLowerCase().includes(searchTerm.toLowerCase()) ||
        paiement.montant.toString().includes(searchTerm) ||
        paiement.reste_a_payer.toString().includes(searchTerm) ||
        paiement.ajouter_par.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredPaiements.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredPaiements.length / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const options = [
        { value: "total", label: "Totalité" },
        { value: "premiere_tranche", label: "Première tranche (30%)" },
        { value: "deuxieme_tranche", label: "Deuxième tranche (40%)" },
        { value: "troisieme_tranche", label: "Troisième tranche (30%)" },
    ];

    // Vérification des accès
    const [accesGroupe, setAccesGroupe] = useState([]);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const accesGroupeStored = localStorage.getItem('accesGroupe');
        if (accesGroupeStored) {
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map(item =>
                            item.acces ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map(access => access.trim()) : []
                        ).flat();
                        setAccesGroupe(cleanedAccessArray);
                        localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                    }
                }
            } catch (error) {
                console.error('Erreur vérification groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) verifGroupe();
    }, [user_id]);

    if (!accesGroupe.includes("Souscription")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2>
                                <FaMoneyBill size={25} className='mr-2' />
                                Journal des paiements
                                {souscription && (
                                    <small className="d-block mt-2">
                                        Pour: {souscription.formation?.nom || souscription.produit?.nom} |
                                        Prix total: {souscription.formation?.prix || souscription.produit?.prix} FCFA |
                                        Reste à payer: {souscription.reste_a_payer} FCFA
                                    </small>
                                )}
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-souscription-admin`}> Liste des souscriptions</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Journal des paiements
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Historique des paiements</h5>
                                <div className="d-flex">
                                    <button
                                        onClick={() => setShowAjoutPaiementModal(true)}
                                        className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        disabled={souscription?.reste_a_payer <= 0}
                                    >
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Ajouter un paiement
                                        </span>
                                    </button>
                                    <button
                                        onClick={() => setShowModifierPaiementModal(true)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedPaiement && Number(selectedPaiement?.montant) !== Number(selectedPaiement?.prix) ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedPaiement || Number(selectedPaiement?.montant) === Number(selectedPaiement?.prix)}
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">
                                            Modifier
                                        </span>
                                    </button>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',
                                            right: '10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}
                            <div className="row wrapper wrapper-content animated fadeInRight">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                    className="form-select bg-light p-1"
                                                    style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control w-25"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '12px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary' onClick={() => handleSort('date_paiement')}>
                                                                Date {sortConfig.key === 'date_paiement'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary' onClick={() => handleSort('versement')}>
                                                                Type {sortConfig.key === 'versement'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary' onClick={() => handleSort('montant')}>
                                                                Montant {sortConfig.key === 'montant'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary' onClick={() => handleSort('reste_a_payer')}>
                                                                Reste {sortConfig.key === 'reste_a_payer'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary' onClick={() => handleSort('ajouter_par')}>
                                                                Enregistré par {sortConfig.key === 'ajouter_par'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentItems.map((paiement) => (
                                                                <tr
                                                                    key={paiement.id}
                                                                    onClick={() => handleRowClick(paiement)}
                                                                    className={`bg-white ${selectedPaiement && selectedPaiement.id === paiement.id ? 'bg-success text-white' : ''}`}
                                                                >
                                                                    <td>{new Date(paiement?.date_paiement).toLocaleDateString()}</td>
                                                                    <td>
                                                                        {paiement?.versement?.includes('total') && (
                                                                            <span className="badge bg-primary ml-1"><FaCheckCircle /> Totalité</span>
                                                                        )}
                                                                        {paiement?.versement?.includes('premiere_tranche') && (
                                                                            <span className="badge bg-warning ml-1"><FaPercentage /> 1ère tranche</span>
                                                                        )}
                                                                        {paiement?.versement?.includes('deuxieme_tranche') && (
                                                                            <span className="badge bg-warning ml-1"><FaPercentage /> 2ème tranche</span>
                                                                        )}
                                                                        {paiement?.versement?.includes('troisieme_tranche') && (
                                                                            <span className="badge bg-warning ml-1"><FaPercentage /> 3ème tranche</span>
                                                                        )}
                                                                    </td>
                                                                    <td>{paiement?.montant} FCFA</td>
                                                                    <td>{paiement?.reste_a_payer} FCFA</td>
                                                                    <td>{paiement?.ajouter_par}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    ) : (
                                                        <div className="col-md-8" style={{ borderRadius: "15px" }}>
                                                            <span
                                                                className="spinner-border spinner-border-lg text-success"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                        </div>
                                                    )}
                                                </table>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Modal d'ajout de paiement */}
                        <Modal show={showAjoutPaiementModal} onHide={() => setShowAjoutPaiementModal(false)}>
                            <Modal.Header>
                                <Modal.Title>Nouveau paiement</Modal.Title>
                            </Modal.Header>
                            {alertModal.message && (
                                <div className={`m-2 alert alert-${alertModal.type}`}>
                                    {alertModal.message}
                                </div>
                            )}
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Type de versement</Form.Label>
                                        <Select
                                            options={options}
                                            value={options.find(option => nouveauPaiement.versement === option.value)}
                                            onChange={(selectedOption) => {
                                                setNouveauPaiement({
                                                    ...nouveauPaiement,
                                                    versement: selectedOption.value
                                                });

                                                // Réinitialiser le montant si on change le type de versement
                                                if (selectedOption.value === 'total') {
                                                    setNouveauPaiement(prev => ({
                                                        ...prev,
                                                        versement: selectedOption.value,
                                                        montant: prev.prix,
                                                        reste_a_payer: 0
                                                    }));
                                                } else {
                                                    setNouveauPaiement(prev => ({
                                                        ...prev,
                                                        versement: selectedOption.value,
                                                        montant: '',
                                                        reste_a_payer: ''
                                                    }));
                                                }
                                            }}
                                            placeholder="Type de versement"
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Montant payé</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="montant"
                                            value={nouveauPaiement.montant}
                                            onChange={(e) => {
                                                const montant = e.target.value;
                                                const reste = nouveauPaiement.prix - montant;
                                                setNouveauPaiement({
                                                    ...nouveauPaiement,
                                                    montant: montant,
                                                    reste_a_payer: reste >= 0 ? reste : 0
                                                });
                                            }}
                                            required
                                        />
                                    </Form.Group>

                                    {nouveauPaiement.versement !== 'total' && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Reste à payer</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="reste_a_payer"
                                                value={nouveauPaiement.reste_a_payer}
                                                readOnly
                                            />
                                        </Form.Group>
                                    )}
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowAjoutPaiementModal(false)}>
                                    Annuler
                                </Button>
                                <Button variant="success" onClick={handlePaiement}>
                                    Enregistrer
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Modal de modification du paiement */}
                        <Modal show={showModifierPaiementModal} onHide={() => setShowModifierPaiementModal(false)}>
                            <Modal.Header>
                                <Modal.Title>Modifier paiement</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Type de versement</Form.Label>
                                        <Select
                                            options={options}
                                            value={options.find(option => selectedPaiement?.versement === option.value)}
                                            onChange={(selectedOption) => {
                                                setSelectedPaiement({
                                                    ...selectedPaiement,
                                                    versement: selectedOption.value
                                                });

                                                // Réinitialiser le montant si on change le type de versement
                                                if (selectedOption.value === 'total') {
                                                    setSelectedPaiement(prev => ({
                                                        ...prev,
                                                        versement: selectedOption.value,
                                                        montant: prev.prix,
                                                        reste_a_payer: 0
                                                    }));
                                                } else {
                                                    setSelectedPaiement(prev => ({
                                                        ...prev,
                                                        versement: selectedOption.value,
                                                        montant: '',
                                                        reste_a_payer: ''
                                                    }));
                                                }
                                            }}
                                            placeholder="Type de versement"
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Montant payé</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="montant"
                                            value={selectedPaiement?.montant}
                                            onChange={(e) => {
                                                const montant = e.target.value;
                                                const reste = selectedPaiement.prix - montant;
                                                setSelectedPaiement({
                                                    ...selectedPaiement,
                                                    montant: montant,
                                                    reste_a_payer: reste >= 0 ? reste : 0
                                                });
                                            }}
                                            required
                                        />
                                    </Form.Group>

                                    {selectedPaiement?.versement !== 'total' && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Reste à payer</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="reste_a_payer"
                                                value={selectedPaiement?.reste_a_payer}
                                                readOnly
                                            />
                                        </Form.Group>
                                    )}
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowModifierPaiementModal(false)}>
                                    Annuler
                                </Button>
                                <Button variant="success" onClick={handleModifierPaiement}>
                                    Enregistrer
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JournalPaiementUtilisateur;